import { format } from "date-fns";
import { parseFilters } from "../../../../../helpers/url.js";
const buildDestination = (destination)=>{
    if (!destination) return '';
    const { type , value  } = destination;
    if (type === 'ACT') {
        const splitValue = value.split('-');
        const provider = splitValue?.shift();
        return [
            type,
            `provider=${provider ? encodeURIComponent(provider) : ''}`,
            `code=${encodeURIComponent(splitValue.join('-'))}`
        ].join('&');
    }
    return [
        type,
        `destinationCode=${value}`
    ].join('&');
};
const buildCalendar = (dates)=>{
    if (!dates?.length) return '';
    const [startDate, endDate] = dates;
    return startDate && endDate ? `${format(startDate, 'yyyy-MM-dd')},${format(endDate, 'yyyy-MM-dd')}` : '';
};
const buildPassengers = (passengers)=>{
    if (!passengers?.adults?.selectedOptions) return '';
    let options = '';
    passengers?.adults.selectedOptions.map((selectedOption, index)=>{
        options += index > 0 ? `,${selectedOption?.toString()}` : `${selectedOption?.toString()}`;
    });
    return options;
};
export function buildUrl(baseUrl, values) {
    const { destination , dates , passengers , testToken  } = values ?? {};
    const filters = {
        destinationType: buildDestination(destination),
        dates: buildCalendar(dates),
        passengers: buildPassengers(passengers),
        testToken: '' + testToken
    };
    return `${baseUrl}?${parseFilters(filters)}`;
}

//# sourceMappingURL=url.js.map